import { useCallback } from 'react';

import { AxiosResponse } from 'axios';
import { useInfiniteQuery, UseInfiniteQueryResult } from 'react-query';
import { UrlParams, PaginatedGoogleCalendarIntegrationList } from 'types';
import { client } from 'utils/api-client';
import { encodeUrlParams, urlParamsFromUrl } from 'utils/functions';

interface QueryKeyType {
  pageParam?: UrlParams;
}

interface IUseGoogleCalendarIntegrations {
  staff?: string;
  limit?: string;
  enabled?: boolean;
}

function useGoogleCalendarIntegrations({
  staff,
  limit = '20',
  enabled = false,
}: IUseGoogleCalendarIntegrations): UseInfiniteQueryResult<
  AxiosResponse<PaginatedGoogleCalendarIntegrationList>
> {
  const fetchGoogleCalendarIntegrations = useCallback(
    ({
      pageParam = { limit, offset: '0' },
    }: QueryKeyType): Promise<AxiosResponse<PaginatedGoogleCalendarIntegrationList>> => {
      const params = pageParam;

      if (staff !== undefined) {
        params.staff = staff;
      }
      return client.get(`google-calendar-integrations/?${encodeUrlParams(params)}`);
    },
    [staff, limit],
  );

  return useInfiniteQuery(['google-calendar-integrations', staff], fetchGoogleCalendarIntegrations, {
    getNextPageParam: page => {
      return page.data.next ? urlParamsFromUrl(page.data.next) : undefined;
    },
    enabled: enabled,
  });
}

export default useGoogleCalendarIntegrations;
